/**
 * Caps the product page quantity input at the selected variant's available stock.
 *
 * Symmetry clamps quantity on the CART page only (CartForm.adjustItemQuantity, scoped to
 * .cart-item__quantity-input). The product form has no equivalent, so this restores the
 * behaviour the store had previously: a customer cannot ask for more units than exist.
 *
 * Stock ceilings are rendered into data-variant-stock-limits as {variantId: available},
 * containing only variants that track inventory and refuse overselling. Variants absent
 * from the map are unlimited.
 */
(() => {
  if (window.themeProductQuantityLimitLoaded) return;
  window.themeProductQuantityLimitLoaded = true;

  const clamp = (input) => {
    const max = parseInt(input.max, 10);
    if (!max || Number.isNaN(max)) return;

    const value = parseInt(input.value, 10);
    if (Number.isNaN(value) || value <= max) return;

    input.value = max;
    if (theme.strings && theme.strings.cartItemsQuantityError && theme.showQuickPopup) {
      theme.showQuickPopup(
        theme.strings.cartItemsQuantityError.replace('[QUANTITY]', max),
        input
      );
    }
  };

  const getLimits = (wrapper) => {
    try {
      return JSON.parse(wrapper.dataset.variantStockLimits || '{}');
    } catch (e) {
      return {};
    }
  };

  // Covers typing and the +/- steppers, which dispatch 'change' on the input.
  document.addEventListener('input', (evt) => {
    const input = evt.target.closest('quantity-wrapper [name="quantity"]');
    if (input) clamp(input);
  });

  document.addEventListener('change', (evt) => {
    const input = evt.target.closest('quantity-wrapper [name="quantity"]');
    if (input) clamp(input);
  });

  // Re-cap when the customer switches variant; each variant has its own stock level.
  document.addEventListener('on:variant:change', (evt) => {
    const form = evt.detail && evt.detail.form;
    const scope = form || document;
    const wrapper = scope.querySelector('quantity-wrapper[data-variant-stock-limits]')
      || document.querySelector('quantity-wrapper[data-variant-stock-limits]');
    if (!wrapper) return;

    const input = wrapper.querySelector('[name="quantity"]');
    if (!input) return;

    const variant = evt.detail && evt.detail.variant;
    const limit = variant ? getLimits(wrapper)[variant.id] : undefined;

    if (limit) {
      input.max = limit;
      clamp(input);
    } else {
      input.removeAttribute('max');
    }
  });

  // Last line of defence: a paste or autofill that skips both events above.
  document.addEventListener('submit', (evt) => {
    const input = evt.target.querySelector
      && evt.target.querySelector('quantity-wrapper [name="quantity"]');
    if (input) clamp(input);
  }, true);
})();
